var t=function(t){return this.__data__.get(t)};export{t as default};
//# sourceMappingURL=_stackGet.js.map
